import { xhrPath } from '@/xhr/connections.js';
import picador from '@/xhr/connections/picador';

export default {
  async getInvitation(invitationId) {
    return await picador.get('getInvitation', xhrPath.invitation + '/' + invitationId);
  },

  async getChallenge(challengeId) {
    return await picador.get('getChallenge', xhrPath.challenge + '/' + challengeId);
  },

  async getChallengeDetails(challengeId) {
    return await picador.get('getChallengeDetails', xhrPath.challengeDetails + '/' + challengeId);
  },

  async getDirectInvitationDetails(directInviteId) {
    return await picador.get(
      'getDirectInvitationDetails',
      xhrPath.directInvite + '/' + directInviteId
    );
  },

  async getUserPendingInvitations(page, resultsPerPage, sort, sortDirection, filterString) {
    const params = { page, resultsPerPage, sort, sortDirection, filterString };
    return await picador.get('getUserPendingInvitations', xhrPath.invitation, {
      params,
    });
  },

  async acceptTeamInvitation(invitationId, privacy) {
    return await picador.post(
      'acceptTeamInvitation',
      `${xhrPath.invitation}/${invitationId}/accept-team-invitation`,
      { privacy }
    );
  },
  async acceptChallengeInvitation(challengeId, privacy) {
    return await picador.post('acceptChallengeInvitation', `${xhrPath.challenge}/${challengeId}`, {
      privacy,
    });
  },
  async declineTeamInvitation(invitationId) {
    return await picador.post(
      'declineTeamInvitation',
      `${xhrPath.invitation}/${invitationId}/decline-invitation`
    );
  },
  async reminderTeamInvitation(invitationId, timeThreshold) {
    return await picador.post(
      'reminderTeamInvitation',
      `${xhrPath.invitation}/${invitationId}/reminder`,
      { timeThreshold }
    );
  },

  async acceptOrgInvitation(invitationId) {
    return await picador.post(
      'acceptOrgInvitation',
      `${xhrPath.invitation}/${invitationId}/accept-organization-invitation`
    );
  },

  async rejectOrgInvitation(invitationId) {
    return await picador.post(
      'rejectOrgInvitation',
      `${xhrPath.invitation}/${invitationId}/reject-organization-invitation`
    );
  },
};
